import styled from 'styled-components';

export const DisplayContainer = styled.main`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
`;
